
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.014.24a1.15 1.15 0 01.865.39l4.905 5.576a.923.923 0 01-1.386 1.22l-4.29-4.877a.125.125 0 00-.188 0L1.63 7.425a.923.923 0 11-1.386-1.22L5.148.633A1.155 1.155 0 016.014.24z","fill":"#161616","fill-opacity":".88"}})])
          )
        }
      }
    